module.exports = __webpack_public_path__ + "f02411e25806a5ea7e2cb9f07fae6742.MP3";